import Mutations from '../../odata/mutations';

export default { ...new Mutations('marketManOrder'), ...new Mutations('marketManOrders') };
